import { API_URL } from '../config';
import { onError } from 'apollo-link-error';
import { ApolloClient } from 'apollo-client';
import { setContext } from 'apollo-link-context';
import Authentication from 'services/Authentication';
import { createUploadLink } from 'apollo-upload-client';
import introspectionQueryResultData from './kms/fragmentTypes';
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import { performanceDataLink } from '../components/PerformanceDataListener/performanceDataLink';

const fragmentMatcher = new IntrospectionFragmentMatcher({ introspectionQueryResultData });

const cache = new InMemoryCache({
  fragmentMatcher,
  addTypename: false
});

const httpLink = createUploadLink({ uri: `${API_URL}/graphql` });
const kmsHttpLink = createUploadLink({ uri: `${API_URL}/graphql/kms` });

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
      'X-Access-Token': Authentication.getToken() || null
    }
  };
});
const logoutLink = onError(({ networkError }) => {
  if (networkError && 'statusCode' in networkError && networkError.statusCode === 401) {
    Authentication.signOut();
    window.location.replace('/login');
  }
});

export const client = new ApolloClient({
  // @ts-ignore
  link: logoutLink.concat(authLink.concat(httpLink)),
  cache
});

export const kmsClient = new ApolloClient({
  // Based on official apollo docs
  // https://www.apollographql.com/blog/graphql/file-uploads/with-react-hooks-typescript-amazon-s3-tutorial/
  // @ts-ignore
  link: logoutLink.concat(authLink.concat(performanceDataLink.concat(kmsHttpLink))),
  cache
});

export default client;
